import React from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import Slider from 'react-slick'
import { GradientBorder } from '../commons'

const OsSpecifications = (props) => {
  const sliderSettings = {
    dots: true,
    infinite: false,
    autoplay: false,
  }
  const attrs = props.subtitle
    ? props.subtitle.subtitle
        .trim()
        .split('\n')
        .map((attr) => {
          let [label, value] = attr.split(';')
          value = value.split('\\n')
          const valueSets = value.map((val) => val.split('$$'))
          return { label: label.trim(), valueSets: valueSets }
        })
    : []

  const comparisonAttrs = props.components[0].subtitle.subtitle
    .trim()
    .split('\n')
  const variants = []
  const comparisons = {}
  const additionalFeatures = []
  let variantHeaders = ['\t']

  props.components.forEach((comp) => {
    if (comp.link === 'comparison') {
      variantHeaders.push(comp.title)
      variants.push(comp.title)
      comparisons[comp.title] = comp.subtitle.subtitle.split('\n')
    } else if (comp.link === 'osComparisonHeaders') {
      return
    } else {
      additionalFeatures.push(comp)
    }
  })

  const specRows = []
  const maxLength = Math.round(attrs.length / 2)

  for (let i = 0; i < maxLength; i++) {
    specRows.push(
      <div className={styles.set}>
        <div className={styles.spec}>
          <span className={styles.label}>{attrs[i].label}</span>
          <div className={styles.attrContainer}>
            {attrs[i].valueSets.map((val, index) => {
              return (
                <span className={styles.value} key={index}>
                  {val.map((subval, idx) => (
                    <span className={styles.subValue} key={idx}>
                      {subval.trim()}
                    </span>
                  ))}
                </span>
              )
            })}
          </div>
        </div>
        {i + maxLength <= attrs.length - 1 && (
          <div className={styles.spec}>
            <span className={styles.label}>{attrs[i + maxLength].label}</span>
            <div className={styles.attrContainer}>
              {attrs[i + maxLength].valueSets.map((val, idx) => (
                <span className={styles.value} key={idx}>
                  {val.map((subval, index) => (
                    <span className={styles.subValue} key={index}>
                      {subval.trim()}
                    </span>
                  ))}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className="wrapper">
      <div className={styles.container}>
        <GradientBorder height="1px" style={{ marginBottom: '19px' }} />
        <h2 className={styles.title}>{props.title}</h2>
        {specRows.length > 0 && <div className={styles.specs}>{specRows}</div>}
        {Object.keys(comparisons).length > 0 && (
          <div className={styles.comparisons}>
            <div className={styles.comparisonHeaders}>
              {variantHeaders.map((header, idx) => (
                <h3 key={idx}>{header}</h3>
              ))}
            </div>
            {comparisonAttrs.map((attr, idx) => (
              <div className={styles.comparisonRow} key={idx}>
                <span className={styles.comparisonAttr}>{attr}</span>
                {variants.map((variant, index) => (
                  <div className={styles.variantValueRow} key={index}>
                    <span className={styles.mobileVariantName}>{variant}</span>
                    <span className={styles.mobileVariantValue}>
                      {comparisons[variant][idx]}
                    </span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        <div className={styles.measurements}>
          <GatsbyImage
            image={props.images[0].gatsbyImageData}
            className={styles.measurementImage}
            alt={props.images[0]?.description}
          />
          <GatsbyImage
            image={props.images[0].gatsbyImageData}
            className={styles.measurementImage}
            alt={props.images[1]?.description}
          />
        </div>
        <div className={styles.mobileMeasurementsImageContainer}>
          <Slider {...sliderSettings}>
            <div className={styles.carousalImageContainer}>
              <GatsbyImage
                image={props.images[0].gatsbyImageData}
                style={{ height: '100%', width: '100%' }}
                alt={props.images[0]?.description}
              />
            </div>
            <div className={styles.carousalImageContainer}>
              <GatsbyImage
                image={props.images[0].gatsbyImageData}
                style={{ height: '100%', width: '100%' }}
                alt={props.images[1]?.description}
              />
            </div>
          </Slider>
        </div>

        <div className={styles.additionalFeatures}>
          <h3 className={styles.additionalFeaturesHeading}>
            {additionalFeatures[0].title}
          </h3>
          <ul className={styles.featurelist}>
            {additionalFeatures[0].subtitle.subtitle
              .trim()
              .split('\n')
              .map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default OsSpecifications
